import { CalculatorLink } from '@/components/blog/CalculatorLink'
import { BlogLink } from '@/components/blog/BlogLink'

export default function Article() {
  return (
    <>
      <p>
        Zdolność kredytowa to kluczowy czynnik decydujący o tym, czy bank udzieli Ci kredytu
        hipotecznego i na jaką kwotę. Zrozumienie jak jest obliczana pomoże Ci lepiej przygotować
        się do procesu ubiegania się o kredyt.
      </p>

      <h2 className="text-2xl font-bold text-foreground mt-8 mb-4">Co to jest zdolność kredytowa?</h2>
      <p>
        Zdolność kredytowa to ocena Twojej możliwości spłaty zobowiązania. Bank analizuje Twoje
        dochody, wydatki, istniejące zobowiązania i historię kredytową, aby określić maksymalną
        kwotę kredytu, jaką może Ci przyznać.
      </p>

      <h2 className="text-2xl font-bold text-foreground mt-8 mb-4">Jak banki obliczają zdolność kredytową?</h2>
      <p>Banki biorą pod uwagę kilka kluczowych czynników:</p>
      <ul className="list-disc pl-6 space-y-2 mt-3">
        <li><strong>Dochody netto</strong> — Twoje <BlogLink slug="ile-zarabiac-na-kredyt-hipoteczny">miesięczne zarobki</BlogLink> po odliczeniu podatków i składek ZUS</li>
        <li><strong>Stałe wydatki</strong> — czynsz, media, ubezpieczenia, alimenty</li>
        <li><strong>Istniejące zobowiązania</strong> — inne kredyty, karty kredytowe, limity w koncie</li>
        <li><strong>Historia w BIK</strong> — Twoja dotychczasowa terminowość spłat</li>
        <li><strong>Wiek i rodzaj umowy</strong> — umowa o pracę na czas nieokreślony jest najlepiej oceniana</li>
      </ul>
      <p className="mt-3">
        Ostatni punkt bywa niedoceniany. Przy działalności gospodarczej, kontrakcie B2B czy
        umowie zlecenie bank <strong>sam wylicza Twój dochód</strong> z dokumentacji podatkowej,
        zamiast przyjąć kwotę z zaświadczenia — a przy ryczałcie stosuje własny wskaźnik
        korygujący. Szczegóły znajdziesz w artykule o{' '}
        <BlogLink slug="kredyt-hipoteczny-dzialalnosc-b2b-zlecenie">kredycie hipotecznym na
        B2B, JDG i umowie zlecenie</BlogLink>.
      </p>

      <h2 className="text-2xl font-bold text-foreground mt-8 mb-4">Zasada 50% dochodu</h2>
      <p>
        Ogólna zasada mówi, że rata kredytu nie powinna przekraczać 50% Twojego dochodu netto.
        W praktyce banki najchętniej udzielają kredytów, gdy rata stanowi 25-35% dochodu.
        Sprawdź jak wygląda Twoja sytuacja:
      </p>
      <ul className="list-disc pl-6 space-y-2 mt-3">
        <li><strong>Do 25% dochodu</strong> — komfortowa sytuacja, bank chętnie udzieli kredytu</li>
        <li><strong>25-35% dochodu</strong> — umiarkowane obciążenie, wymaga ostrożnego planowania</li>
        <li><strong>35-50% dochodu</strong> — napięty budżet, bank może wymagać dodatkowych zabezpieczeń</li>
        <li><strong>Ponad 50% dochodu</strong> — ryzykownie, większość banków odmówi kredytu</li>
      </ul>

      <div className="mt-4">
        <CalculatorLink section="affordability">
          Sprawdź swoją zdolność w kalkulatorze RatyGo
        </CalculatorLink>
      </div>

      <h2 className="text-2xl font-bold text-foreground mt-8 mb-4">Jak zwiększyć zdolność kredytową?</h2>
      <ul className="list-disc pl-6 space-y-2 mt-3">
        <li><strong>Spłać istniejące zobowiązania</strong> — zamknij karty kredytowe i limity, których nie używasz</li>
        <li><strong>Zwiększ <BlogLink slug="wklad-wlasny-kredyt-hipoteczny">wkład własny</BlogLink></strong> — im więcej wpłacisz z góry, tym mniejszy kredyt potrzebujesz</li>
        <li><strong>Wydłuż <BlogLink slug="okres-kredytu-hipotecznego">okres kredytowania</BlogLink></strong> — niższa rata oznacza wyższą zdolność (ale wyższy koszt całkowity)</li>
        <li><strong>Weź kredyt z kimś</strong> — wspólny kredyt ze współmałżonkiem zwiększa dochody brane pod uwagę</li>
        <li><strong>Zadbaj o historię w BIK</strong> — regularne, terminowe spłaty poprawiają Twój scoring</li>
      </ul>

      <h2 className="text-2xl font-bold text-foreground mt-8 mb-4">Praktyczny przykład</h2>
      <p>
        Przy dochodzie netto 10 000 zł i braku innych zobowiązań, bank może zaakceptować ratę
        do ok. 3 500 zł (35% dochodu). Przy <BlogLink slug="co-to-jest-wibor">oprocentowaniu 7,85%</BlogLink> i okresie 25 lat, pozwala to
        na kredyt w wysokości ok. 460 000 zł.
      </p>
      <p className="mt-3">
        Zdolność kredytowa to pierwszy krok. Jeśli kupujesz pierwsze mieszkanie, sprawdź też
        pełną ścieżkę procesu w poradniku{' '}
        <BlogLink slug="jak-dostac-kredyt-hipoteczny-na-pierwsze-mieszkanie">jak dostać kredyt
        hipoteczny na pierwsze mieszkanie</BlogLink> — od wkładu własnego po akt notarialny.
      </p>

      <div className="mt-4">
        <CalculatorLink propertyPrice={575000} downPaymentPercent={20} loanYears={25} section="affordability">
          Oblicz ratę dla swojej sytuacji
        </CalculatorLink>
      </div>
    </>
  )
}
